import React, { useEffect, useState } from "react";

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  geocodeByPlaceId,
} from "react-places-autocomplete";

const GooglePlace = ({ saveAddress, defaultAddress, index, setValue,type }) => {
  const [address, setAddress] = useState("");

  useEffect(() => {
    setAddress(defaultAddress);
  }, [defaultAddress]);

  const handleChange = (address) => {
    console.log("address",address);
    setAddress(address);
  };

  const handleSelect = async (address, placeId) => {
    console.log(placeId,"address12",address);
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        saveAddress(address, latLng, index);
        setAddress(address);
      });
    const [place] = await geocodeByPlaceId(placeId);
    console.log("address_components", place.address_components);
    const { long_name: postalCode = "" } =
      place.address_components.find((c) => c.types.includes("postal_code")) ||
      "";
      const { long_name: country = "" } =
      place.address_components.find((c) => c.types.includes("country")) ||
      "";
    const { long_name: state = "" } =
      place.address_components.find((c) =>
        c.types.includes("administrative_area_level_1")
      ) || "";
    const { long_name: city = "" } =
      place.address_components.find((c) =>
        c.types.includes("locality")
      ) || "";
    const { long_name: street = "" } =
      place.address_components.find((c) => c.types.includes("route")) || "";

      console.log("types",type);
      if(type == "personal"){
        setValue(`postal_code`, postalCode ?? "");
        setValue(`state`, state ?? "");
        setValue(`city`, city ?? "");
        setValue(`country`, country ?? "");
      }else{
        setValue(`businessCity`, city ?? "");
        setValue(`businessState`, state ?? "");
        setValue(`business_postal_code`, postalCode ?? "");
        setValue(`businessCountry`, country ?? "");
        // setValue(`street`, street ?? "");
      }
  };

  return (
    <PlacesAutocomplete
      value={address}
      onChange={handleChange}
      onSelect={handleSelect}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <input
            {...getInputProps({
              placeholder: "Search Places ...",
              className: "location-search-input form-control pr-5",
            })}
          />
          <div className="autocomplete-dropdown-container locationDropDown">
            {loading && <div className="mb2">Loading...</div>}
            {suggestions.map((suggestion) => {
              const className = suggestion.active
                ? "suggestion-item--active"
                : "suggestion-item";
              // inline style for demonstration purpose
              const style = suggestion.active
                ? { backgroundColor: "#fafafa", cursor: "pointer" }
                : { backgroundColor: "#ffffff", cursor: "pointer" };
              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className,
                    style,
                  })}
                  className="autocomDropdown pr-5"
                  key={suggestion.placeId}
                >
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
};

export default GooglePlace;
